import { Component, OnInit, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { MenuService } from 'src/app/core/menu/menu.service';
import { SettingsService } from 'src/app/core/settings/settings.service';
import { DataService } from 'src/app/Service/data.service';
import { consumermenu } from './../../routes/consumer-menu';
declare var $: any;

@Component({
  selector: 'app-applicant-sidebar',
  templateUrl: './applicant-sidebar.component.html',
  styleUrls: ['./applicant-sidebar.component.scss']
})
export class ApplicantSidebarComponent implements OnInit {

  constructor(public menu: MenuService, private DataServiceObj: DataService, public settings: SettingsService, public injector: Injector) {

  }

    consumermenuItems: Array<any>;
  router: Router;
  sbclickEvent = 'click.sidebar-toggle';
  $doc: any = null;
  p = 1;
  term;
  response;
  permissions;
  menuItems: Array<any>;
    consumermenuItems1: any[];
  FinalData = [];

  ngOnInit() {

    this.menu.addConsumerMenu(consumermenu);

    this.router = this.injector.get(Router);
    //   console.log(this.consumermenuItems.forEach(x=>{console.log(x)}))

    this.router.events.subscribe((val) => {
          // close any submenu opened when route changes
          this.removeFloatingNav();
          // scroll view to top
          window.scrollTo(0, 0);
          // close sidebar on route change
          this.settings.setLayoutSetting('asideToggled', false);
      });

      // enable sidebar autoclose from extenal clicks
    this.anyClickClose();
    if (JSON.parse(sessionStorage.getItem('consumerLogin'))){
        const UsersData = JSON.parse(sessionStorage.getItem('consumerLogin'));

        const reportType = UsersData.Data.reportType;
        this.consumermenuItems = [];
        this.consumermenuItems1 = [];

        this.consumermenuItems1 = this.menu.getConsumerMenu();

        if (reportType === 'disclosure'){
            const index = this.consumermenuItems1.findIndex(x => x.text === 'Request Disclosure');
            if (index >= 0){
                this.consumermenuItems1.splice(index, 1);
            }

        }else{
            const index = this.consumermenuItems1.findIndex(x => x.text === 'Request Dispute');
            // console.log("if dispute",this.consumermenuItems1[index]);

            if (index >= 0){
                this.consumermenuItems1.splice(index, 1);
            }
        }
        this.consumermenuItems = this.consumermenuItems1;
        // console.log(this.consumermenuItems.forEach(x=>{console.log(x)}))
      }

  }
  anyClickClose() {
      this.$doc = $(document).on(this.sbclickEvent, (e) => {
          if (!$(e.target).parents('.aside-container').length) {
              this.settings.setLayoutSetting('asideToggled', false);
          }
      });
  }

  ngOnDestroy() {
      if (this.$doc) {
          this.$doc.off(this.sbclickEvent);
      }
  }

  toggleSubmenuClick(event) {

      const ul = $(event.currentTarget.nextElementSibling);

      // Leaf items have no submenu — let routerLink handle navigation
      if (!ul.length) {
          return;
      }

      // Parent items use an empty href; always block reload (including collapsed/hover modes)
      event.preventDefault();

      if (!this.isSidebarCollapsed() && !this.isSidebarCollapsedText() && !this.isEnabledHover()) {

          // hide other submenus
          const parentNav = ul.parents('.sidebar-subnav');
          $('.sidebar-subnav').each((idx, el) => {
              const $el = $(el);
              // if element is not a parent or self ul
              if (el !== parentNav[0] && el !== ul[0]) {
                  this.closeMenu($el);
              }
          });

          // any child menu should start closed
          ul.find('.sidebar-subnav').each((idx, el) => {
              this.closeMenu($(el));
          });

          // toggle UL height
          const ulHeight = ul.css('height');
          if (ulHeight === 'auto' || parseInt(ulHeight, 10)) {
              this.closeMenu(ul);
          }
          else {
              // expand menu
              ul.on('transitionend', () => {
                  ul.css('height', 'auto').off('transitionend');
              }).css('height', ul[0].scrollHeight);
              // add class to manage animation
              ul.addClass('opening');
          }

      }

  }

  // Close menu collapsing height
  closeMenu(elem) {
      elem.css('height', elem[0].scrollHeight); // set height
      elem.css('height', 0); // and move to zero to collapse
      elem.removeClass('opening');
  }

  toggleSubmenuHover(event) {
      const self = this;
      if (this.isSidebarCollapsed() || this.isSidebarCollapsedText() || this.isEnabledHover()) {
          event.preventDefault();

          this.removeFloatingNav();

          const ul = $(event.currentTarget.nextElementSibling);
          const anchor = $(event.currentTarget);

          if (!ul.length) {
              return; // if not submenu return
          }

          const $aside = $('.aside-container');
          const $asideInner = $aside.children('.aside-inner'); // for top offset calculation
          const $sidebar = $asideInner.children('.sidebar');
          const mar = parseInt($asideInner.css('padding-top'), 0) + parseInt($aside.css('padding-top'), 0);
          const itemTop = ((anchor.parent().position().top) + mar) - $sidebar.scrollTop();

          const floatingNav = ul.clone().appendTo($aside);
          const vwHeight = document.body.clientHeight;

          // let itemTop = anchor.position().top || anchor.offset().top;

          floatingNav
              .addClass('nav-floating');

          // each item has ~40px height
          // multiply to force space for at least N items
          const safeOffsetValue = (40 * 5);
          const navHeight = floatingNav.outerHeight(true) + 2; // 2px border
          const safeOffset = navHeight < safeOffsetValue ? navHeight : safeOffsetValue;

          const displacement = 25; // displacement in px from bottom

          // if not enough space to show N items, use then calculated 'safeOffset'
          const menuTop = (vwHeight - itemTop > safeOffset) ? itemTop : (vwHeight - safeOffset - displacement);

          floatingNav
              .removeClass('opening') // necesary for demo if switched between normal//collapsed mode
              .css({
                  position: this.settings.getLayoutSetting('isFixed') ? 'fixed' : 'absolute',
                  top: menuTop,
                  bottom: (floatingNav.outerHeight(true) + menuTop > vwHeight) ? (displacement + 'px') : 'auto'
              });

          floatingNav
              .on('mouseleave', () => { floatingNav.remove(); })
              .find('a').on('click', function(e) {
                  e.preventDefault(); // prevents page reload on click
                  // get the exact route path to navigate
                  const routeTo = $(this).attr('route');
                  if (routeTo) { self.router.navigate([routeTo]); }
              });

          this.listenForExternalClicks();

      }

  }

  listenForExternalClicks() {
      const $doc = $(document).on('click.sidebar', (e) => {
          if (!$(e.target).parents('.aside-container').length) {
              this.removeFloatingNav();
              $doc.off('click.sidebar');
          }
      });
  }

  removeFloatingNav() {
      $('.nav-floating').remove();
  }

  isSidebarCollapsed() {
      return this.settings.getLayoutSetting('isCollapsed');
  }
  isSidebarCollapsedText() {
      return this.settings.getLayoutSetting('isCollapsedText');
  }
  isEnabledHover() {
      return this.settings.getLayoutSetting('asideHover');
  }

}
